<div class="col w100">
    <div class="w100 align-center space-between row">
        <h2>Generic Streams</h2>
        <div class="row gap-16 align-center">
            @if(showSearch === false){
            <rr-icon
                name="search"
                class="w24 pointer"
                color="nutral"
                (click)="showSearch = true"
            ></rr-icon>
            }@else {
            <div class="row align-center gap-8">
                <rr-input
                    type="search"
                    placeholder="Search for Stream"
                    (keyup)="search()"
                    [(ngModel)]="searchString"
                ></rr-input>
                <rr-icon
                    name="close"
                    class="pointer"
                    color="nutral"
                    (click)="showSearch = false"
                ></rr-icon>
            </div>
            }
            <div class="row gap-8">
                <rr-btn
                    iconStart="reload"
                    type="Secondary"
                    size="Medium"
                    (click)="updateAgents()"
                    >Update Agents</rr-btn
                >
                <rr-btn
                    iconStart="add"
                    type="Primary"
                    size="Medium"
                    (click)="openTrackCatSelection()"
                    >Add Stream</rr-btn
                >
            </div>
        </div>
    </div>
    <div class="w100">
        New generic streams, not "the old" ones like user-tinder etc.
    </div>
</div>
<div class="listwrapper col gap-8 w100">
    <div class="w100 card col gap-8" *ngFor="let stream of streamsList">
        <div class="row space-between w100">
            <div class="col gap-4">
                <div class="row gap-24 align-center">
                    <h4 class="strong">{{ stream.name }}</h4>
                    <div class="row gap-8">
                        <rr-badge tone="success">{{ stream.status }}</rr-badge>
                        <rr-badge tone="info">{{ stream.type }}</rr-badge>
                        @if(stream.globalStream !== true){
                            <rr-badge tone="error">Private</rr-badge>
                            @if($any(stream).companies.length > 0) {
                                <div class="company-container">
                                    <rr-badge *ngFor="let c of $any(stream).companies; let i = index" tone="error" class="company-badge">{{c.name}}</rr-badge>
                                </div>
                            }@else {
                                <rr-badge tone="error" class="company-badge">No assigned Customer</rr-badge>
                            }
                        }@else{
                        <rr-badge tone="warning">Global </rr-badge>
                        }
                    </div>
                </div>
                <div class="row gap-8 tiny">
                    <span>Steps: {{ stream.steps?.length || 0 }}</span>
                    <span *ngIf="stream.dateCreate">|</span>
                    <span *ngIf="stream.dateCreate"
                        >created:
                        {{ stream.dateCreate | getLocaldateByTime }}</span
                    >
                    <span *ngIf="stream.dateUpdate">|</span>
                    <span *ngIf="stream.dateUpdate"
                        >updated:
                        {{ stream.dateUpdate | getLocaldateByTime }}</span
                    >
                </div>
            </div>
            <div class="row gap-8 align-center">
                <rr-btn
                    size="Small"
                    type="Link"
                    (click)="deleteStream(stream?.id)"
                    >delete</rr-btn
                >
                <rr-btn
                    iconStart="edit"
                    size="Small"
                    type="Secondary"
                    (click)="stream.id ? editStream(stream.id) : null"
                    >Edit</rr-btn
                >
                <rr-btn
                iconStart="copy"
                size="Small"
                type="Secondary"
                (click)="stream.id ? duplicateStream(stream.id) : null"
                >Duplicate</rr-btn>
            </div>
        </div>
        <rr-divider></rr-divider>
        <div class="w100 row gap-8 space-between">
            <div class="row gap-4">
                <rr-badge *ngFor="let cat of stream.categoryId">{{
                    cat | getCategoryNameById
                }}</rr-badge>
            </div>
        </div>
    </div>
</div>
@if(isLoading === true){
<rr-spinner></rr-spinner>
}
